export const CollegeConstant = {
    BATCH_NAME:"Batch Name",
    ADD_COLLEGE : "Add College",
    COLLEGE_NAME : "College Name",
    STATE : "State",
    CITY : "City",
    MOBILENO : "Mobile No",
    COLLEGE_LOGO : "College Logo",
    UPLOAD_LOGO:"Upload Logo",
    UPDATE_COLLEGE:"Update College",
    COLLEGE_REQUIRED:"College is required",
    COLLEGE_BATCH_NAME:"Batch name is required",
    COLLEGE_BATCH_NAME_LENGTH:"Maximum characters should not more than 100.",
    COLLEGE_BATCH_DETAILS : "College Batch Details",
    COLLEGE_DETAILS : "College Details",
    COLLEGE_STATE:"State",
    COLLEGE_CITY:"City"
}

export const ChangePasswordConstant = {
  CHANGE_PASSWORD : "Change Password",
  OLD_PASSWORD : "Old Password",
  NEW_PASSWORD : "New Password",
  CONFIRM_NEW_PASSWORD : "Confirm new password",
  CHANGE_PASSWORD_HEADER_TEXT : "Your new password must be different from previously used password.",
  PASSWORD_PATTERN:"Passwords must be at least 6 characters long, contain at least one number, and have a mixture of uppercase and lowercase letters"
}

export const ResetPasswordConstant = {
  RESET_PASSWORD : "Reset Password",
  HEADER : "Set New Password",
  HEADER_TEXT : "Your new password must be different from previously used password.",
  NEW_PASSWORD : "New Password",
  CONFIRM_NEW_PASSWORD : "Confirm New Password",
  BACK_TO_LOGIN : "Back To Login"
}

export const LogInConstant = {
  LOGIN : "Sign In",
  HEADER_TEXT : "Welcome Back!",
  EMAIL : "Email Address",
  PASSWORD : "Password",
  REMEMBER_ME : "Remember Me",
  FORGOT_PASSWORD : "Forgot Password?"
}

export const ForgotPasswordConstant = {
  NEXT : "Next",
  FORGOT_PASSWORD : "Forgot Password?",
  HEADER_TEXT : "No worries, we’ll send you reset instructions.",
  EMAIL : "Email Address",
  BACK_TO_LOGIN : "Back To Login"
}

export const CollegeBatchConstant = {
  ADD_BATCH : "Add New Batch",
  CollegeName:"College Name ",
  BatchName:" Batch Name ",
  BatchYear:"Batch Year ",
  AddCollegeBatch:"Add College Batch",
  EditCollegeBatch:"Edit College Batch",
  COLLEGE_BATCH_DETAILS : "College Batch Details",
  TotalStudent: "Total Students"
}

export const ParentTechnologyPreferenctConstant = {
  ADD_PARENT_TECHNOLOGY : "Add New Technology",
  ParentTechnologyName:"Parent Technology Name ",
  TechnologyLogo:" Technology Logo ",
  AddParentTechnology:"Add Parent Technology",
  EditParentTechnology:"Edit Parent Technology",
  UPDATE_PARENT_TECHNOLOGY:"Update Parent Technology",
}

export const ChildTechnologyPreferenctConstant = {
  ADD_CHILD_TECHNOLOGY : "Add New Technology",
  UPDATE_CHILD_TECHNOLOGY:"Update Child Technology",
  ChildTechnologyName:"Child Technology Name ",
  ParentTechnologyName:"Parent Technology Name ",
  TechnologyLogo:" Technology Logo ",
  AddChildTechnology:"Add Child Technology",
  EditChildTechnology:"Edit Child Technology"
}

export const TestConstant = {
  ADD_TEST : "Add Exam",
  NameOfTest:"Name Of Exam",
  Date:"Exam Date",
  TestTime:"Exam Time",
  TestDuration:"Exam Duration",
  NumberofStudent:"No. Of Student",
  AttemptedStudent : "Attempted Student" ,
  LiveResult:"Live/Result",
  Export:"Export Excel",
  NameOfStudent:"Student Name",
  StartTime:"Start Time",
  EndTime:"End Time",
  Wrong:"Wrong",
  MarkScores:"Mark Scores",
  Result:"Result",
  College:"Selected Colleges",
  SelectedBatch:"Selected Batches",
  SCHEDULE_EXAM_WIZARD_LABEL:"Schedule A Exam",
  EXAM_NAME:"Exam Name",
  QUESTION_SETS_WIZARD_LABEL: "Question Sets",
  SELECT_QUESTION_SETS:"Select Question Set",
  CLEAR_ALL:"Clear All",
  DELETE_ALL:"Delete All",
  BATCH_WIZARD_LABEL:"Batch",
  SELECT_COLLEGE:"Selected Colleges",
  SELECT_BATCH:"Select Batch",
  SUBMIT_TYPE:"Submit Type",
  EmailId:"Email ID",
  PhoneNumber: "Phone No.",
  PendingStudents : "Pending Students",
  ExportPdf: "Export PDF"
}

export const QuestionSetConstant = {
  ADD_QUESTIONSET: "Add Question Set",
  EDIT_QUESTIONSET: "Edit Question Set",
  QuestionSetName:"Question Set Name",
  QuestionSetDetails: "Question Set Details",
  QuestionCount: "No. Of Questions"
}

export const UserConstant = {
  ADD_USER : "Add User",
  FullName:"Full Name",
  EmailId:"Email ID",
  MobileNo:"Mobile No.",
  RoleName:"Role Name",
  FirstName:"First Name",
  LastName:"Last Name",
  UserDetails : "User Details"
}

export const CompanyConstant = {
  ADD_COMPANY : "Add Company",
  COMPANY_NAME:"Company Name",
  COMPANY_CODE:"Company Code",
  EMAIL:"Email ID",
  MOBILE_NO:"Mobile No.",
  ADDRESS:"Address",
  COMPANY_WEBSITE:"Company Website",
  COMPANY_LOGO:"Company Logo",
  UPLOAD_LOGO:"Upload Logo",
  COMPANY_ABOUT: "Company About",
  INDUSTRY: "Industry",
  COMPANY_SIZE:"Company Size",
  COMPANY_DETAILS: "Company Details"
}

export const StudentLableConstant = {
  StudentName : "Student Name",
  CollegeName:"College Name",
  BatchYear:"Batch Year",
  EmailAddress:"Email ID",
  PhoneNo:"Phone No.",
  UploadFile:"Upload File",
  DownloadTemplate:"Download Template",
  AddStudent:"Add Student",
  BatchName:"Batch Name",
  ExportDetails:"Export Excel",
  ExportPdf:"Export PDF",
  StudentDetails: "Student Details"
}

export const QuestionConstant = {
  TYPE_OF_QUESTION: "Type Of Question",
  QUESTION_SET: "Question Set",
  QUESTION_TYPE: "Question Type",
  QUESTION_SET_NAME:"Question Set Name",
  QUESTION: "Question",
  QUESTION_NAME:"Question Name/Paragraph Test",
  PARAGRAPH_TEXT: "Paragraph",
  IMAGE: "Image",
  OPTION_COUNT:"Option Count/Question Count",
  ADD_QUESTION: "Add Question",
  EDIT_QUESTION: "Edit Question",
  VIEW_QUESTION: "View Question",
  OPTION_A : "Option A",
  OPTION_B : "Option B",
  OPTION_C : "Option C",
  OPTION_D : "Option D",
  ANSWER:"Answer",
  REASON :"Reason"
}

export const FooterConstant = {
  VERSION : "Version",
  COPYRIGHT : "Copyright",
  ALL_RIGHTS_RESERVED : "All Rights Reserved."
}

export const CompanyUserConstant = {
  ADD_USER : "Add Company User",
  FIRST_NAME : "First Name",
  LAST_NAME : "Last Name",
  COMPANY_NAME : "Company Name",
  EMAIL : "Email ID",
  MOBILE_NO:"Mobile No.",
  ROLE_NAME: "Role Name",
  COMPANY_USER_DETAILS : "Company User Details"
}

export const JobConstant = {
  TITLE : "Title",
  SALARY_PACKAGE : "Salary Package",
  TAGS : "Tags",
  TECHNOLOGY : "Technology",
  APPLY_USER : "No of Vacancies",
  ADDRESS:"Address",
  JOB_DESCRIPTIONS: "Job Description",
  RESPONSIBILITIES: "Responsibilities",
  COMPANY_ABOUT: "About Company",
  WEBSITE: "Website",
  INDUSTRY: "Industry",
  COMPANY_SIZE:"Company Size",
  OFFICE_ADDRESS:"Office Address",
  MIN_EXPERIENCE:"Min Experience",
  MIN_SALARY:"Minimum Salary",
  MAX_SALARY:"Maximum Salary",
  STATE:"State",
  CITY:"City"
}

export const AppliedJobConstant = {
  FULLNAME: "Full Name",
  NOTICE_PERIOD: "Notice Period",
  TOTAL_EXPERIENCE:"Total Experience",
  RESUME:"Resume",
  COVER_LETTER:"Cover Letter",
  TITLE: "Title",
  PHONE_NO: "Phone Number",
  Email_ID: "Email ID",
  ExportDetails:"Export Excel",
  ExportPdf:"Export PDF",
  DETAILS: "Candidate  Details"
}

export const CommonConstantLabel = {
    PROFILE:"Profile",
    CHANGE_PASSWORD:"Change Password",
    SIGN_OUT:"Log Out"
}

export const VerificationPageLabel = {
    CHECK_YOUR_EMAIL:"Check Your Email",
    WE_SEND_A_CODE:"We sent a code to ",
    DID_NOT_RECIEVE_MAIL:"Didn’t Receive The Email?",
    EXPIRE_IN:"Expire In:",
    TIME_Expired: "Your time is expired",
    BACK_TO_LOGIN:"Back To Login",
    CONTINUE:"Continue",
    CLICK_TO_RESEND:"Click To Resend"
}